<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="copy1">Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Senior Editor: Roxane Cerda</p>
<p class="copy">Technical Editor: Elizabeth Tisinger Beese</p>
<p class="copy">Copy Editor: Sheila Chapman Ryan</p>
<p class="copy">Illustrator: Lisa Lauch</p>
<p class="copy">Cover and Interior Designer: Adrienne Smitke</p>
<p class="copy">Photographer: Brent Kane</p>
<p class="copy">Production Coordinator: Zinnia Heinzmann</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?9901045e